// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1jHvt","right":"Footer_right__1Jh46","buttons":"Footer_buttons__1MF5O"};